<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)" v-if="item">
		<el-page-header @back="goBack" content="售后信息"></el-page-header>
<table class="table" cellpadding="0" cellspacing="0">
			<tr>
				<th>订单号</th>
				<td>{{item.order_master.order_sn}}</td>
				<th>退款状态</th>
				<td colspan="3">
					<el-tag size="small" effect="dark" type="danger" v-if="item.status == 0">进行中</el-tag>
					<el-tag size="small" effect="dark" type="warning" v-else-if="item.status == 10">已拒绝</el-tag>
					<el-tag size="small" effect="dark" v-else-if="item.status == 20">已完成</el-tag>
					<el-tag size="small" effect="dark" type="warning" v-else-if="item.status == 30">已取消</el-tag>

				</td>
			</tr>
			<tr>
				<th>下单用户</th>
				<td>
					<div class="avatar" v-if="item.user">
						<img :src="item.user.avatar" />
						{{item.user.nick_name}}
					</div>
				</td>
				<th>收货人</th>
				<td>{{item.order_master.consignee}}</td>
				<th>手机号</th>
				<td colspan="3">{{item.order_master.mobile}}</td>
			</tr>
			<tr>
				<th>商品</th>
				<td>
					<div class="thumb">
						<img :src="item.order_goods.pic_url" />
						{{item.order_goods.product_name}}
					</div>
				</td>
				<th>规格</th>
				<td>
					{{item.order_goods.sku_name}}
				</td>
				<th>数量</th>
				<td>
					{{item.order_goods.number}} 件
				</td>
			</tr>
			<tr>
				<th>退款原因</th>
				<td colspan="5">{{item.apply_desc}}</td>
			</tr>
			<tr v-if="item.images.length">
				<th>退款凭证</th>
				<td colspan="5">
					<div class="el-images">
						<el-image :src="val" fit="cover" :preview-src-list="item.images" v-for="val in item.images"></el-image>
					</div>
				</td>
			</tr>
			<tr v-if="item.name || item.address || item.mobile">
				<th>退货地址</th>
				<td>{{item.address}}</td>
				<th>收货人</th>
				<td>{{item.name}}</td>
				<th>手机号</th>
				<td>{{item.mobile}}</td>
			</tr>
			<tr>
				<th>申请时间</th>
				<td>{{item.created_date}}</td>
				<th>订单金额</th>
				<td>{{item.order_goods.total_fee}} 元</td>
				<th>退款类型</th>
				<td>
					<template v-if="item.type == 1">
						仅退款
					</template>
					<template v-else-if="item.type == 2">
						退货退款
					</template>
				</td>
			</tr>
			<tr v-if="item.express_id">
				<th>退货时间</th>
				<td>{{item.send_time}}</td>
				<th>快递公司</th>
				<td>{{item.express_name ? item.express_name : item.express}}</td>
				<th>快递单号</th>
				<td>{{item.express_no}}</td>
			</tr>
			<tr v-if="item.status == -1">
				<th>驳回时间</th>
				<td>{{item.fail_time}}</td>
				<th>驳回原因</th>
				<td colspan="3">{{item.reason}}</td>
			</tr>
			<tr v-else-if="item.status == 4">
				<th>退款时间</th>
				<td>{{item.refund_time}}</td>
				<th>退款金额</th>
				<td>
				    <el-link type="danger" :underline="false">{{item.refund_money}} 元</el-link>
				</td>
				<th>退款单号</th>
				<td>{{item.ordersn}}</td>
			</tr>
		</table>

		<el-form ref="form" label-position="right" v-model="param" label-width="auto" show-message inline-message status-icon v-if="item.status == 0">
			<el-form-item label="审核结果" v-if="item.audit_status == 0">
				<el-radio-group v-model="param.audit_status">
					<el-radio :label="10" v-if="(item.status == 0)">通过</el-radio>
					<el-radio :label="20">驳回</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="退款金额" v-if="param.audit_status == 10">
				<el-radio-group v-model="param.is_part">
					<el-radio :label="0">全部退款</el-radio>
					<el-radio :label="1">部分退款</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="驳回原因" v-if="param.audit_status == 20">
				<el-input clearable type="textarea" autosize v-model="param.refuse_desc" placeholder="请输入驳回原因"></el-input>
			</el-form-item>
			<template v-if="item.type == 2 && param.audit_status == 10">
				<el-form-item label="收货人">
					<el-input clearable v-model="param.name" placeholder="请输入收货人"></el-input>
				</el-form-item>
				<el-form-item label="联系电话">
					<el-input clearable maxlength="11" v-model="param.mobile" placeholder="请输入联系电话"></el-input>
				</el-form-item>
				<el-form-item label="退货地址">
					<el-input clearable v-model="param.address" placeholder="请输入退货地址"></el-input>
				</el-form-item>
			</template>
			<el-form-item label="退款金额" v-if="param.audit_status == 10 && item.type == 1">
				<el-input v-model="param.refund_money"  :disabled="param.is_part ? false : true" placeholder="请输入退款金额" style="width: 200px;">
					<template #append>元</template>
				</el-input>
			</el-form-item>
			<el-form-item v-if="item.audit_status == 0" v-auth="['supplier/order.refund/audit']">
				<el-button type="primary" @click="submit">保存</el-button>
			</el-form-item>

		</el-form>
		<el-form ref="form" label-position="right" :model="param" label-width="auto" show-message inline-message status-icon v-if="item.type == 2
				&& item.audit_status == 10
				&& item.is_user_send
				&& !item.is_receipt">
			<el-form-item label="审核结果">
				<el-input :value="item.type == 1 ? '仅退款' : '退货退款'" disabled style="width: 200px;">
				</el-input>
			</el-form-item>
			<el-radio-group v-model="param.is_part">
				<el-radio :label="0">全部退款</el-radio>
				<el-radio :label="1">部分退款</el-radio>
			</el-radio-group>
			<el-form-item label="退款金额">
				<el-input v-model="param.refund_money" placeholder="请输入退款金额" :disabled="param.is_part ? false : true"  style="width: 200px;">
					<template #append>元</template>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="handleReceipt" v-auth="['supplier/order.refund/receipt']">确认收货</el-button>
				<el-button type="warning" @click="handleRefuse" v-auth="['supplier/order.refund/receipt']">拒绝退款</el-button>
			</el-form-item>
		</el-form>

		<el-form ref="form" label-position="right" :model="param1" label-width="auto" show-message inline-message status-icon v-if="item.type == 2
				&& item.audit_status == 10
				&& item.is_user_send == 0">

			<el-form-item label="物流公司">
				<el-select v-model="param1.express_id" clearable placeholder="请选择物流公司">
					<el-option v-for="item in express" :value="item.id" :label="item.express_name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="物流单号">
				<el-input clearable v-model="param1.express_sn" placeholder="请输入物流单号"/>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="confirmDeliver" v-auth="['supplier/order.refund/confirmDeliver']">已寄回</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
export default {
	data() {
		return {
			item: null,
			param:{
				is_part: 0
			},
			param1: {},
			isLoad: false,
			id: this.$route.query.id,
			express: [],
		}
	},
	created() {
		this.axios.post('/supplier/data/listLogisticsForSelect').then(res => {
			this.express = res.data.list
			this.loadList()
		}).catch(() => {
		})

		this.loadData()
	},
	methods: {
		loadData() {

			this.isLoad = !this.isLoad
			this.axios.get('supplier/order.refund/detail',{params:{
				id:this.id
			}}).then(res => {
				this.isLoad = !this.isLoad
				this.item = res.data.detail
				this.param = {
					is_part: 0,
					refund_money:  this.item.order_goods.total_fee
				}
				this.$forceUpdate();
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		goBack() {
			this.$router.back(-1)
		},
		submit() {
			this.isLoad = !this.isLoad
			let params = this.param
			if (params.audit_status == 10 && this.item.type == 2) {
				if (!params.name) {
					return this.$message.error({
						message: '请填写寄回收货人'
					});
				}

				if (!params.mobile) {
					return this.$message.error({
						message: '请填写寄回手机号'
					});
				}

				if (!params.address) {
					return this.$message.error({
						message: '请填写寄回地址'
					});
				}
			}


			this.axios.post('supplier/order.refund/audit', {
				id: this.id,
				form: params
			}).then(res => {
				this.isLoad = !this.isLoad
				this.$message.success({
					message: '保存成功'
				});
				this.goBack()
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		handleReceipt() {
			this.isLoad = !this.isLoad
			let params = this.param
			this.axios.post('supplier/order.refund/receipt', {
				id: this.id,
				form: params
			}).then(res => {
				this.isLoad = !this.isLoad
				this.$message.success({
					message: '保存成功'
				});
				this.goBack()
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		handleRefuse: function () {
			this.$prompt('', '拒绝原因', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			}).then(({value}) => {
				if (value == '') {
					this.$message.success({
						message: '请输入拒绝原因'
					});
					return
				}
				if (this.isLoad) {
					return
				}
				this.isLoad = true
				this.axios.post('supplier/order.refund/refuse', {
					id: this.id,
					form: {
						refuse_desc: value
					}
				}).then(res => {
					this.isLoad = false
					this.$message.success({
						message: '保存成功'
					});
					this.goBack()
				}).catch(() => {
					this.isLoad = !this.isLoad
				})

			}).catch(() => {

			});
		},
		confirmDeliver() {
			this.isLoad = !this.isLoad
			let params = this.param1
			this.axios.post('supplier/order.refund/confirmDelivery', {
				id: this.id,
				form: params
			}).then(res => {
				this.isLoad = false
				this.$message.success({
					message: '保存成功'
				});
				this.loadData()
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		}
	}
}
</script>
<style scoped>
.el-form{
	margin-top: 20px;
}
:deep().el-descriptions{
	margin-top: 20px;
}
.table{
	width: 100%;
	border-collapse: collapse;
	margin-top: 20px;
}
.table th{
	line-height: 1.5;
	background: #fafafa;
	color: #909399;
	font-weight: bold;
	text-align: center;
	border:1px solid #ebeef5;
	padding:12px 10px;
	width: 10%;
}
.table td{
	line-height: 1.5;
	color: #909399;
	border:1px solid #ebeef5;
	padding:12px 10px;
	color: #333;
	width: 10%;
}
.el-images{
	display: flex;
}
.el-images .el-image{
	height: 30px;
	margin-right: 10px;
}
</style>
